var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyFinCardIcon(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    width: 40,
    height: 40,
    rx: 11.1111,
    fill: "#E4F2E6",
    style: (_ref2 = {
      fill: "#E4F2E6"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.8941 0.9490 0.9020)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2305 26.6665C14.2305 27.8938 13.2356 28.8887 12.0083 28.8887C10.781 28.8887 9.78613 27.8938 9.78613 26.6665V21.1108C9.78613 19.8836 10.781 18.8887 12.0083 18.8887C13.2356 18.8887 14.2305 19.8836 14.2305 21.1108V26.6665ZM29.7866 11.1113C31.0139 11.1113 32.0088 12.1063 32.0088 13.3336V26.6664C32.0088 27.8937 31.0134 28.8887 29.7861 28.8887C28.5588 28.8887 27.5635 27.8937 27.5635 26.6664V17.7778C27.5635 16.5506 26.5686 15.5557 25.3413 15.5557C24.114 15.5557 23.1191 16.5506 23.1191 17.7778V26.6665C23.1191 27.8938 22.1242 28.8887 20.897 28.8887C19.6697 28.8887 18.6748 27.8938 18.6748 26.6665V17.7779C18.6748 16.5506 17.6799 15.5557 16.4526 15.5557H12.0083C10.781 15.5557 9.78613 14.5608 9.78613 13.3335C9.78613 12.1062 10.781 11.1113 12.0083 11.1113H29.7866Z",
    fill: "#1A4338",
    style: (_ref3 = {
      fill: "#1A4338"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.1020 0.2627 0.2196)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFinCardIcon);
export default __webpack_public_path__ + "static/media/myFinCardIcon.a506c51d.svg";
export { ForwardRef as ReactComponent };